import type { ReactElement } from "react";

import { t } from "i18next";

import {
  EmptyInputsStyled,
  PlaceholderImage,
  TitleText,
  DescriptionText,
} from "./style";

// eslint-disable-next-line n/no-unpublished-import
import automationPlaceholder from "../../../../assets/images/jpg/placeholder.jpg";

export const DefaultSection = (): ReactElement => {
  return (
    <EmptyInputsStyled>
      <TitleText>{t("placeholder.title")}</TitleText>
      <PlaceholderImage
        src={new URL(automationPlaceholder, import.meta.url).href}
        alt=""
      />
      <DescriptionText>{t("placeholder.description")}</DescriptionText>
    </EmptyInputsStyled>
  );
};
